"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function TagList(_a) {
    var tags = _a.tags, setTags = _a.setTags;
    return react_1.default.createElement(react_1.default.Fragment, null, tags.map(function (tag, index) {
        return react_1.default.createElement(storybook_1.Videos.Tag, { tag: tag, key: index, tags: tags, setTags: setTags });
    }));
}
exports.default = TagList;
